import { Button, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";

import BGc from "./assets/homebg.png";
import logomain from "./assets/main-logo.png";
// import main from "./assets/main.png";
// import apes from "./assets/apes.png";
// import maleApe from "./assets/maleape.png";
// import femaleApe from "./assets/femaleape.png";
// import rightCloud from "./assets/maincloud-right.png";
// import leftCloud from "./assets/maincloud-left.png";
import leftPurpleCloud from "./assets/cloud-left.png";
import rightPurpleCloud from "./assets/cloud-right.png";

import Lh from "./assets/lh.png";
import Th from "./assets/th.png";
import "./Header.css";
import { MintNFT } from "../MintNFT/MintNFT";
import HeadBottom from "../HeaderBottom/HeadBottom";
import { useState } from "react";
function Header({ mintPage, openLogout, setopenLogout }) {
  const [mint, setmint] = useState(false);
  const pb = useMediaQuery("(max-width:1040px)");

  const hide = useMediaQuery("(max-width:600px)");
  const query400 = useMediaQuery("(min-width:400px)");
  const query600 = useMediaQuery("(min-width:600px)");
  console.log("====================================");
  console.log(query600, "600");
  console.log(query400, "400");
  console.log("====================================");

  return (
    <>
      {/* <Zoom duration={500}> */}

      <Box
        width="100%"
        // maxHeight={"500px"}
        sx={{
          backgroundImage: `url(${BGc})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          // backgroundPosition: "center",
          boxSizing: "border-box",
          paddingTop: "20px",
          fontFamily: "'Baloo Bhai 2', cursive",
        }}
      >
        <Box textAlign={"center"} mt={6}>
          <img
            src={logomain}
            alt=""
            style={{ width: "100%", maxWidth: hide ? "50%" : "38%" }}
          />
        </Box>

        {/* Querry  */}

        {/* <MintNFT /> */}

        <Box textAlign={"center"} mt={2} pt="80px">
          <Typography
            fontSize={{ xs: "20px", sm: "30px", md: "34px" }}
            // fontSize={pb ? "24px" : "30px"}
            variant="h3"
            sx={{
              color: "white",
              fontFamily: "'Baloo Bhai 2', cursive",
              fontWeight: "bold",
            }}
            mt={{ xs: -9 }}
          >
            Make it Official on Blockchain
          </Typography>
        </Box>

        <Box
          display="flex"
          alignItems="center"
          flexDirection="column"
          width="100%"
          pb={pb ? "0px" : "200px"}
        >
          <a
            style={{ textDecoration: "none" }}
            href=" https://discord.com/invite/soulmapes"
            target="_blank"
          >
            <Button
              sx={{
                "&:hover": {
                  background: "#101440",
                },
                marginTop: "34px",
                background: "#CF1B52",
                color: "white",
                borderRadius: "30px",
                padding: "12px 34px",
                zIndex: "1",
                fontFamily: "'Baloo Bhai 2', cursive",
                marginBottom: "20px",
              }}
            >
              JOIN OUR DISCORD
            </Button>
          </a>
        </Box>

        <HeadBottom />
      </Box>
    </>
  );
}

export default Header;
